class PlanService {
  static isTrial(plan: Dto.Plan) {
    return this.isV1(plan) && plan.details.payment.payment_schedule === 5
  }

  static isOnceOff(plan: Dto.Plan) {
    return (
      this.isV1(plan) &&
      [4, 5, 7].includes(plan.details.payment.payment_schedule)
    )
  }

  static isV1(
    plan: Dto.Plan
  ): plan is Dto.Plan & { details: NonNullable<Dto.Plan['details']> } {
    return !!plan.version
  }
}

export { PlanService }
